<ion-content>
  <div>
    <div class="flex-space-between" style="padding: 15px 5px 0 3px">
      <div class="button-container">
        <ion-searchbar
          mode="ios"
          class="rounded-search-bar"
          placeholder="Search members..."
          showCancelButton="never"
          (ionChange)="reloadMembers()"
          [(ngModel)]="searchText"
        >
        </ion-searchbar>
        <div [hidden]="!selectedMembers.length">
          <ion-button (click)="sendMessage()" [disabled]="isLoading">
            <ion-icon name="mail-outline"></ion-icon>
            <span class="text-with-left-icon hidden-sm"> Send email </span>
          </ion-button>
          <ion-button fill="clear" color="dark" (click)="selectedMembers = []" [disabled]="isLoading">
            Clear selection
          </ion-button>
        </div>
      </div>
      <div class="button-container" [hidden]="selectedMembers.length">
        <ion-button color="dark" (click)="manageAgents()" class="hidden-sm" *ngIf="isProjectOwner">
          <ion-icon name="body"></ion-icon>
          <span class="text-with-left-icon hidden-sm"> Manage Agents </span>
        </ion-button>
        <ion-button
          *ngIf="isSuperAdmin || isDev"
          fill="clear"
          color="dark"
          (click)="syncChannel()"
          [disabled]="isLoading"
          class="hidden-sm"
        >
          <ion-icon name="sync-outline"></ion-icon>
          <span class="text-with-left-icon hidden-sm"> Sync Members </span>
        </ion-button>
        <ion-button fill="clear" color="dark" (click)="downloadMembers()" [disabled]="isLoading" class="hidden-sm">
          <ion-icon name="cloud-download-outline"></ion-icon>
          <span class="text-with-left-icon hidden-sm"> Download CSV </span>
        </ion-button>
        <ion-button fill="dark" color="dark" (click)="sendMessage()" [disabled]="isLoading">
          <ion-icon name="mail-outline"></ion-icon>
          <span class="text-with-left-icon hidden-sm"> Send email </span>
        </ion-button>
      </div>
    </div>
    <div style="padding: 5px 16px 0">
      <ion-button
        class="btn-small"
        [fill]="memberTypeFilter === 'all' ? 'solid' : 'clear'"
        [color]="memberTypeFilter === 'all' ? 'light' : 'dark'"
        (click)="memberTypeFilter = 'all'; reloadMembers()"
      >
        All
      </ion-button>
      <ion-button
        class="btn-small"
        [fill]="memberTypeFilter === 'agents' ? 'solid' : 'clear'"
        [color]="memberTypeFilter === 'agents' ? 'light' : 'dark'"
        (click)="memberTypeFilter = 'agents'; reloadMembers()"
      >
        Teammates
      </ion-button>
      <ion-button
        class="btn-small"
        [fill]="memberTypeFilter === 'customers' ? 'solid' : 'clear'"
        [color]="memberTypeFilter === 'customers' ? 'light' : 'dark'"
        (click)="memberTypeFilter = 'customers'; reloadMembers()"
      >
        Customers
      </ion-button>
    </div>
  </div>

  <ion-card class="outline-card">
    <ngx-datatable
      class="material"
      [columnMode]="ColumnMode.force"
      [limit]="100"
      [headerHeight]="50"
      [footerHeight]="50"
      [rowHeight]="50"
      [scrollbarH]="true"
      [rows]="members"
      [selected]="selectedMembers"
      [selectionType]="SelectionType.checkbox"
      [selectAllRowsOnPage]="false"
      [displayCheck]="false"
      [reorderable]="true"
      (select)="onSelect($event)"
      paginated
      [dataSource]="membersDataSource"
      [loadingIndicator]="isLoading"
    >
      <ngx-datatable-column
        [width]="30"
        [sortable]="false"
        [canAutoResize]="false"
        [draggable]="false"
        [resizeable]="false"
        [headerCheckboxable]="true"
        [checkboxable]="true"
      >
      </ngx-datatable-column>
      <ngx-datatable-column name="Name" [minWidth]="250" prop="user.name">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <span>
            <a *ngIf="row.user?.name" (click)="viewProfile(row)">{{row.user?.name}}</a>
          </span>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column name="Email" [minWidth]="250" prop="user.email">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <span> {{row.user?.email}} </span>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column name="Role" [maxWidth]="170" [minWidth]="170" [sortable]="false">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <ion-badge color="success" *ngIf="row.user?.isExternal">Customer</ion-badge>
          <ion-badge color="dark" *ngIf="!row.user?.isExternal && !row.isExternal && isMemberAnAgent(row)">
            Agent
          </ion-badge>
          <ion-badge color="dark" *ngIf="!row.user?.isExternal && !row.isExternal && !isMemberAnAgent(row)">
            Teammate
          </ion-badge>
          <ion-badge color="success" *ngIf="!row.user?.isExternal && row.isExternal"> Internal Customer </ion-badge>
        </ng-template>
      </ngx-datatable-column>
    </ngx-datatable>
  </ion-card>
</ion-content>
